import React from "react";

import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { logout } from "service/auth";

import { AppLogoSpinner } from "components/AppLogoSpinner/AppLogoSpinner";
import { ConfirmationDialog } from "components/ConfirmationDialog/ConfirmationDialog";
import { RemoveButton } from "components/styled";
import useEmployee from "hooks/useEmployee";
import { useRevokeConsents } from "state/useRevokeConsents";

export function RevokeConsents() {
  const { t } = useTranslation();
  const { employeeData } = useEmployee();
  const [revokeConsentsDialogOpen, setRevokeConsentsDialogOpen] = React.useState(false);
  const toggleRevokeConsentsDialogState = () => {
    setRevokeConsentsDialogOpen((prev) => !prev);
  };

  const { mutate: onRevokeConsents, isLoading } = useRevokeConsents();

  const handleRevokeConsents = () => {
    onRevokeConsents(
      {
        countryCode: Number(employeeData?.countryCode),
        clientInternalNumberGOS: Number(employeeData?.clientInternalNumberGos),
      },
      {
        onSuccess: () => {
          toast.success(t("hbh.revokeConsentSuccessfully.label"));
          logout();
        },
      }
    );
  };

  return (
    <>
      {isLoading && <AppLogoSpinner />}
      <RemoveButton
        data-help="profile-revoke-consents"
        style={{
          marginLeft: "auto",
          marginBottom: "20px",
        }}
        appearance="subtle"
        onClick={() => setRevokeConsentsDialogOpen(true)}
        disabled={isLoading}
      >
        {t("hbh.revokeConsents.label")}
      </RemoveButton>

      <ConfirmationDialog
        isOpen={revokeConsentsDialogOpen}
        toggleOpen={toggleRevokeConsentsDialogState}
        onConfirm={handleRevokeConsents}
        description={t("hbh.revokeConsentInfo.label")}
        confirmLabel={t("hbh.revokeConsents.label")}
        title={t("hbh.revokeConsents.label")}
        isDisabled={isLoading}
      />
    </>
  );
}
